import useReveal from "@/hooks/useReveal";

const STORY_IMAGE =
  "https://customer-assets.emergentagent.com/job_afrqa-luxury/artifacts/x1soojwk_c8096233-b39b-44e4-b5ab-6e375337c685.JPG";

export default function BrandStory() {
  const r1 = useReveal();
  const r2 = useReveal();
  const r3 = useReveal();

  return (
    <section
      id="story"
      data-testid="brand-story-section"
      className="relative bg-[#0a0a0a] py-24 md:py-40 border-y border-[#1a1a1a]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div
          ref={r1.ref}
          className={`reveal ${r1.inView ? "in-view" : ""} text-center mb-20`}
        >
          <span className="font-label text-[#d4af37]">— The Heritage —</span>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-12 gap-6 md:gap-8">
          <div
            ref={r2.ref}
            className={`reveal ${
              r2.inView ? "in-view" : ""
            } col-span-12 lg:col-span-7 bg-[#0c0c0c] border border-[#1f1f1f] p-10 md:p-16`}
          >
            <h2 className="font-display text-[clamp(2rem,4.4vw,4rem)] leading-[1.06] tracking-tight text-white">
              Designed for{" "}
              <span className="font-editorial italic gold-text-gradient">
                the culture.
              </span>
            </h2>
            <p className="mt-8 text-[#cfcfca] text-lg leading-[1.85] max-w-[55ch] font-light">
              AFRQA™ turns the silhouette of a continent into wearable
              statements of culture. We design slowly, make less, and
              number every piece — built to outlast the moment.
            </p>

            <div className="mt-12 grid grid-cols-3 gap-4 md:gap-8 border-t border-[#1f1f1f] pt-10">
              <div>
                <p className="font-editorial italic gold-text-gradient text-4xl">
                  001
                </p>
                <span className="font-label text-[#8a8a85] mt-2 block">
                  Edition
                </span>
              </div>
              <div>
                <p className="font-editorial italic gold-text-gradient text-4xl">
                  300
                </p>
                <span className="font-label text-[#8a8a85] mt-2 block">
                  Pieces
                </span>
              </div>
              <div>
                <p className="font-editorial italic gold-text-gradient text-4xl">
                  ∞
                </p>
                <span className="font-label text-[#8a8a85] mt-2 block">
                  Heritage
                </span>
              </div>
            </div>
          </div>

          <div
            ref={r3.ref}
            className={`reveal reveal-delay-1 ${
              r3.inView ? "in-view" : ""
            } col-span-12 lg:col-span-5 zoom-wrap aspect-[4/5] lg:aspect-auto bg-[#0c0c0c] border border-[#1f1f1f]`}
          >
            <img
              src={STORY_IMAGE}
              alt="AFRQA editorial portrait"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
